<template>
    <v-card color="primary" dark>
        <v-card-text>
            <div class="data-row">
                <span class="data-row-title font-weight-medium">Zeitraum:</span>
                <span>{{_.get(event, 'date_range')}}</span>
            </div>
            <div class="data-row" v-if="_.get(event, 'online')">
                <span class="data-row-title font-weight-medium">Link:</span>
                <span><a :href="_.get(event, 'url')">{{_.get(event, 'url')}}</a></span>
            </div>
            <div class="data-row" v-if="location && !_.get(event, 'online')">
                <span class="data-row-title font-weight-medium">Veranstaltungsort:</span>
                <span>{{_.get(location, 'name')}}</span>
            </div>
            <div class="data-row" v-if="location && !_.get(event, 'online')">
                <span class="data-row-title font-weight-medium">Straße:</span>
                <span>{{_.get(location, 'street') + ' ' + _.get(location, 'street_suffix')}}</span>
            </div>
            <div class="data-row" v-if="location && !_.get(event, 'online')">
                <span class="data-row-title font-weight-medium">Ort:</span>
                <span>{{_.get(location, 'postcode') + ' ' + _.get(location, 'city')}}</span>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "EventBox",
        props: {
            event: Object,
            location: Object
        }
    }
</script>

<style scoped>

</style>
